module.exports = __webpack_public_path__ + "static/media/State-bank-of-Mysore.589c8232.png";